import React from 'react';
import { ApolloProvider } from '@material-bank/apollo-client';
import { CustomerProvider } from '@material-bank/customer';
import { ProjectsCustomerProvider } from '@material-bank/projects-utils';
import { App } from '@mb/App';

import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { Provider } from 'react-redux';
import { ThemeContainer } from 'ui-widgets';
import { AppContainer } from './containers/AppContainer';
import { SearchContextProvider, FiltersContextProvider } from './contexts';
import store from './redux/store';
import { isCuratedCollectionPage as helperIsCuratedCollectionPage } from './utils/helpers';

const ProductSearch = () => {
  const isCuratedCollectionPage = helperIsCuratedCollectionPage();

  return (
    <App>
      <ApolloProvider>
        <ProjectsCustomerProvider>
          <CustomerProvider>
            <IntlProvider>
              <ThemeContainer>
                <Provider store={store}>
                  <FiltersContextProvider>
                    <SearchContextProvider>
                      <AppContainer
                        displayAddAllToCartButton={isCuratedCollectionPage}
                        displayHeaderFilterButton
                        displayHeaderFilters
                        displayViewOptions={!isCuratedCollectionPage}
                      />
                    </SearchContextProvider>
                  </FiltersContextProvider>
                </Provider>
              </ThemeContainer>
            </IntlProvider>
          </CustomerProvider>
        </ProjectsCustomerProvider>
      </ApolloProvider>
    </App>
  );
};

export default ProductSearch;
